var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8105 0.833008H4.75C4.15326 0.833008 3.58097 1.07445 3.15901 1.50422C2.73705 1.93399 2.5 2.51689 2.5 3.12467V19.1663H9.91667V17.6386H4V3.12467C4 2.92208 4.07902 2.72778 4.21967 2.58452C4.36032 2.44127 4.55109 2.36079 4.75 2.36079H10.75V7.70801H16V10.833H17.5V6.62787L11.8105 0.833008ZM14.9395 6.18023L12.25 3.44092V6.18023H14.9395Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 9.16699,
    width: 8.33333,
    height: 1.41667,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.8335,
    y: 12.5,
    width: 4.16667,
    height: 1.41667,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5835 19.2148C13.5429 19.2148 12.6578 18.85 11.9281 18.1203C11.1984 17.3905 10.8335 16.5054 10.8335 15.4648C10.8335 14.4243 11.1984 13.5391 11.9281 12.8094C12.6578 12.0797 13.5429 11.7148 14.5835 11.7148C15.6241 11.7148 16.5092 12.0797 17.2389 12.8094C17.9686 13.5391 18.3335 14.4243 18.3335 15.4648C18.3335 16.5054 17.9686 17.3905 17.2389 18.1203C16.5092 18.85 15.6241 19.2148 14.5835 19.2148ZM16.4985 16.8607L15.9793 17.3798L14.215 15.6155V13.013H14.952V15.3142L16.4985 16.8607Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReport);
export default __webpack_public_path__ + "static/media/newReport.3029fb89bb20c410cec8a3f1443de157.svg";
export { ForwardRef as ReactComponent };